import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { SendEmailService } from './send-email.service'
import { error } from '@angular/compiler/src/util';
import { send } from 'q';
import * as $ from 'jquery';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  constructor(public sendEmailService: SendEmailService) {}

  requestNewInfoForm = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    emailAddress: new FormControl(''),
    phoneNumber: new FormControl(''),
    message: new FormControl('')
  })

  onSubmit() {
    console.warn(this.requestNewInfoForm.value);

    this.sendEmailService.sendEmail(this.requestNewInfoForm.value.firstName, 
      this.requestNewInfoForm.value.lastName,
      this.requestNewInfoForm.value.emailAddress, 
      this.requestNewInfoForm.value.phoneNumber, 
      this.requestNewInfoForm.value.message).subscribe(
        data => {
          console.log(data);
        },
        error => {
          console.log(error);
        },
        () => {

        }
      )
    this.requestNewInfoForm.reset();
    alert("Your information has been sent.  We will respond within 24-48 hours!")
  }

  ngOnInit() {
  }

}
